export { ArticlePromoBlock } from './articlePromoBlock.component';
